// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2rC53","head":"ProcedureTableInfo_head__3kR9z"};